// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyABM0D_ScpvyjqQlbM1udsUT3l71RaJ7oo",
  authDomain: "civyx-erp.firebaseapp.com",
  projectId: "civyx-erp",
  storageBucket: "civyx-erp.firebasestorage.app",
  messagingSenderId: "678334710292",
  appId: "1:678334710292:web:317ccf9e0deb0753b75d01",
  measurementId: "G-LVPR4NDSTP"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
getAnalytics(app); // analytics (optional, no need to export)

// Initialize Firestore and export it
export const db = getFirestore(app);
